import React from 'react';

const Logo = ({ size = 'md', showText = true, className = '', compact = false }) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12', // Aumentado de h-10 w-10
    lg: 'h-16 w-16', // Aumentado de h-12 w-12
    xl: 'h-20 w-20'  // Aumentado de h-16 w-16
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-lg',   // Aumentado de text-base
    lg: 'text-xl',   // Aumentado de text-lg
    xl: 'text-2xl'   // Aumentado de text-xl
  };

  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo da empresa - imagem */}
      <div className={`${sizeClasses[size]} mr-3 flex-shrink-0`}>
        <img
          src="/Logo.png"
          alt="TW Alcantara"
          className="w-full h-full object-contain"
          onError={(e) => {
            // Fallback para as iniciais se a imagem não carregar
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        {/* Fallback com iniciais */}
        <div className={`${sizeClasses[size]} bg-primary-600 rounded-lg flex items-center justify-center hidden`}>
          <span className="text-white font-bold text-lg">TW</span>
        </div>
      </div>
      
      {/* Texto da empresa - oculto quando compact */}
      {showText && !compact && (
        <div className="flex flex-col">
          <span className={`font-bold text-gray-900 dark:text-white ${textSizes[size]}`}>
            TW Alcantara
          </span>
          <span className={`text-xs text-gray-600 dark:text-gray-400 ${size === 'sm' ? 'text-xs' : 'text-sm'}`}>
            Sistema de Gestão
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo; 